/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Rest_Live_BodyInputs */

const en_us2_native_release_rest_live_body = /** @type {(inputs: Native_Release_Rest_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to return to your workout.`)
};

const pt_br2_native_release_rest_live_body = /** @type {(inputs: Native_Release_Rest_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque para voltar ao treino.`)
};

const pt_pt2_native_release_rest_live_body = /** @type {(inputs: Native_Release_Rest_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque para voltar ao treino.`)
};

/** @type {(inputs: Native_Release_Rest_Live_BodyInputs) => LocalizedString} */
const es_419_native_release_rest_live_body = en_us2_native_release_rest_live_body;

/** @type {(inputs: Native_Release_Rest_Live_BodyInputs) => LocalizedString} */
const fr_fr2_native_release_rest_live_body = en_us2_native_release_rest_live_body;

/** @type {(inputs: Native_Release_Rest_Live_BodyInputs) => LocalizedString} */
const de_de2_native_release_rest_live_body = en_us2_native_release_rest_live_body;

/** @type {(inputs: Native_Release_Rest_Live_BodyInputs) => LocalizedString} */
const it_it2_native_release_rest_live_body = en_us2_native_release_rest_live_body;

/**
* | output |
* | --- |
* | "Tap to return to your workout." |
*
* @param {Native_Release_Rest_Live_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_rest_live_body = /** @type {((inputs?: Native_Release_Rest_Live_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Rest_Live_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_rest_live_body(inputs)
	if (locale === "es-419") return es_419_native_release_rest_live_body(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_rest_live_body(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_rest_live_body(inputs)
	if (locale === "de-DE") return de_de2_native_release_rest_live_body(inputs)
	if (locale === "it-IT") return it_it2_native_release_rest_live_body(inputs)
	return en_us2_native_release_rest_live_body(inputs)
});
export { native_release_rest_live_body as "native-release.rest_live_body" }